import { Link } from "react-router-dom";
import { ArrowUpRight, Package } from "lucide-react";

/**
 * A cross-sell CTA card promoting an end-to-end setup quote (POS + Card Payments + Web/App).
 * Clicks route to /contact with ?interest=Bundle — full setup which the Contact page pre-selects.
 */
export default function BundleCTA() {
  const href = "/contact?interest=" + encodeURIComponent("Bundle — full setup");

  return (
    <section className="py-20 md:py-28 bg-white" data-testid="bundle-cta-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="relative overflow-hidden rounded-3xl bg-[#0a0a0a] text-white p-10 md:p-14">
          <div className="absolute -right-20 -top-24 w-96 h-96 bg-[#FF5A1F]/15 blur-3xl rounded-full" />
          <div className="absolute -left-10 -bottom-24 w-72 h-72 bg-[#FF5A1F]/10 blur-3xl rounded-full" />

          <div className="relative grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#FF5A1F]/15 border border-[#FF5A1F]/25">
                <Package size={14} className="text-[#FF5A1F]" />
                <span className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#FF5A1F]">One quote · everything</span>
              </div>
              <h3 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight mt-6 leading-[1.05]">
                Setting up something new<span className="text-[#FF5A1F]">?</span>
              </h3>
              <p className="mt-6 text-gray-300 leading-relaxed text-base md:text-lg max-w-2xl">
                Card payments, till system, website, app — get everything spec&rsquo;d, sourced and set up in one quote. One team, one point of contact, start to finish.
              </p>
            </div>

            <div className="lg:col-span-4 lg:text-right">
              <Link
                to={href}
                data-testid="bundle-cta-link"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 text-base font-semibold text-[#0a0a0a] bg-white hover:bg-[#FF5A1F] hover:text-white rounded-full transition-all duration-300 hover:-translate-y-0.5 shadow-lg"
              >
                Get a bundled quote <ArrowUpRight size={18} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
